import React from 'react';

import MemberCheckedOutContent from '../MemberCheckedOutContent';

function CompletedRoomContent({ checkoutContent, viewProps }) {
  return (
    <>
      <MemberCheckedOutContent dialogDatas={checkoutContent.dialogDatas} />
    </>
  );
}

export default CompletedRoomContent;
